module.exports = __webpack_public_path__ + "img/profile.5ace1552.svg";